<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span
        ><router-link class="decoration" to="/tinternalcourses/index"
          >Internal Courses</router-link
        ><span class="pfimg3"><i class="fa fa-angle-right"></i></span>Survey
        Questions
      </h6>
      <div class="container-fluid">
        <div class="d-flex justify-content-end mb-1">
          <button
            type="button"
            class="btn btn-sm btn-outline-primary bdr-rad"
            @click="goBack"
          >
            Back
          </button>
        </div>
        <div v-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>
        <div v-if="message" class="alert alert-success">{{ message }}</div>
        <div class="card custom_bdr_rds shadow p-2">
          <div class="card-body custom_bdr_rds">
            <h6 class="purchitem mb-2"><b>Added Survey Question</b></h6>
            <div class="table-responsive">
              <table class="table table-hover table-sm table-borderless">
                <thead class="background_color2">
                  <tr class="custom-label2">
                    <th>Category</th>
                    <th>Question</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in assigned" :key="item.id">
                    <td>{{ item.category || "-" }}</td>
                    <td>{{ item.question }}</td>
                    <td>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary bdr-rad"
                        @click="removeQuestion(item.id)"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!assigned.length">
                    <td colspan="3" class="text-muted">No results found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="card custom_bdr_rds shadow p-2 mt-3">
          <div class="card-body custom_bdr_rds">
            <h6 class="purchitem mb-2">
              <b>New Survey Question for Course</b>
            </h6>
            <div class="d-flex justify-content-between mb-2">
              <span class="text-muted small"
                >Total {{ filteredQuestions.length }} items.</span
              ><input
                v-model="search"
                class="form-control form-control-sm bdr-rad w-25"
                placeholder="Search"
              />
            </div>
            <div class="table-responsive">
              <table class="table table-hover table-sm table-borderless font-size_def">
                <thead class="background_color2">
                  <tr class="custom-label2">
                    <th>
                      <input
                        type="checkbox"
                        :checked="allSelected"
                        @change="toggleAll($event)"
                      />
                    </th>
                    <th>Category</th>
                    <th>Question</th>
                    <th>Remarks</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in filteredQuestions" :key="item.id">
                    <td>
                      <input
                        v-model="selected"
                        type="checkbox"
                        :value="item.id"
                      />
                    </td>
                    <td>{{ item.category || "-" }}</td>
                    <td>{{ item.question }}</td>
                    <td>
                      <textarea
                        v-model="remarks[item.id]"
                        rows="2"
                        class="form-control form-control-sm bdr-rad"
                      ></textarea>
                    </td>
                    <td></td>
                  </tr>
                  <tr v-for="(item, index) in newQuestions" :key="item.key">
                    <td>
                      <b-icon
                        icon="dash-lg"
                        scale="1"
                        class="ticourse-action-icon text-dark"
                        @click="removeNewQuestion(index)"
                      ></b-icon>
                    </td>
                    <td>
                      <input
                        v-model="item.category"
                        class="form-control form-control-sm bdr-rad"
                      />
                    </td>
                    <td>
                      <textarea
                        v-model="item.question"
                        rows="2"
                        class="form-control form-control-sm bdr-rad"
                      ></textarea>
                    </td>
                    <td>
                      <textarea
                        v-model="item.remarks"
                        rows="2"
                        class="form-control form-control-sm bdr-rad"
                      ></textarea>
                    </td>
                    <td>
                      <b-icon
                        icon="plus-lg"
                        scale="1"
                        class="ticourse-action-icon text-dark"
                        @click="addNewQuestion"
                      ></b-icon>
                    </td>
                  </tr>
                  <tr v-if="!filteredQuestions.length && !newQuestions.length">
                    <td colspan="5" class="text-muted">
                      No survey questions found.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-group mt-3 mb-2">
              <label class="custom-label text-dark"
                >Are you want to save questionnaire with new version</label
              ><select
                v-model="newVersion"
                class="form-control form-control-sm bdr-rad w-25"
              >
                <option value="">Select</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <div class="d-flex justify-content-end mt-2">
              <button
                type="button"
                class="btn btn-sm btn-primary bdr-rad"
                :disabled="
                  isSaving || (!selected.length && !validNewQuestions.length)
                "
                @click="saveQuestions"
              >
                Add to Class
              </button>
            </div>
          </div>
        </div>
      </div>
      <br><br>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "./../../layout/TopNavbar.vue";
import ContentFooter from "./../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      token: authService.isLoggedIn(),
      assigned: [],
      questions: [],
      selected: [],
      remarks: {},
      newQuestions: [
        { key: Date.now(), category: "", question: "", remarks: "" },
      ],
      newVersion: "",
      search: "",
      isSaving: false,
      errorMessage: "",
      message: "",
    };
  },
  computed: {
    courseId() {
      return this.$route.query.course_id || this.$route.query.id;
    },
    filteredQuestions() {
      const value = this.search.toLowerCase();
      return this.questions.filter(
        (item) =>
          !value ||
          (item.category + " " + item.question).toLowerCase().includes(value)
      );
    },
    allSelected() {
      return (
        this.filteredQuestions.length > 0 &&
        this.filteredQuestions.every((item) => this.selected.includes(item.id))
      );
    },
    validNewQuestions() {
      return this.newQuestions.filter(
        (item) => item.category.trim() && item.question.trim()
      );
    },
  },
  mounted() {
    this.loadQuestions();
  },
  methods: {
    async loadQuestions() {
      try {
        const { data } = await axios.get(
          "/ticourses/surveyquestion?id=" + this.courseId,
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.assigned = data.assigned || [];
        this.questions = data.questions || [];
      } catch (error) {
        this.errorMessage = "Unable to load survey questions.";
      }
    },
    toggleAll(event) {
      const ids = this.filteredQuestions.map((item) => item.id);
      this.selected = event.target.checked
        ? Array.from(new Set(this.selected.concat(ids)))
        : this.selected.filter((id) => !ids.includes(id));
    },
    addNewQuestion() {
      this.newQuestions.push({
        key: Date.now() + Math.random(),
        category: "",
        question: "",
        remarks: "",
      });
    },
    removeNewQuestion(index) {
      if (this.newQuestions.length > 1) this.newQuestions.splice(index, 1);
      else
        this.newQuestions[0] = {
          key: Date.now(),
          category: "",
          question: "",
          remarks: "",
        };
    },
    async saveQuestions() {
      this.isSaving = true;
      this.message = "";
      this.errorMessage = "";
      try {
        await axios.post(
          "/ticourses/createclass?id=" + this.courseId,
          {
            survey: {
              selection: this.selected,
              remarks: this.remarks,
              new_version: this.newVersion,
              new_questions: this.validNewQuestions,
            },
          },
          { headers: { Authorization: "Bearer " + this.token } }
        );
        this.selected = [];
        this.remarks = {};
        this.newVersion = "";
        this.newQuestions = [
          { key: Date.now(), category: "", question: "", remarks: "" },
        ];
        this.message = "Survey questions added successfully.";
        await this.loadQuestions();
      } catch (error) {
        this.errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          "Unable to add survey questions.";
      } finally {
        this.isSaving = false;
      }
    },
    async removeQuestion(id) {
      if (
        !window.confirm("Are you sure you want to delete this survey question?")
      )
        return;
      try {
        await axios.delete("/ticourses/deletesurveyquestion?id=" + id, {
          headers: { Authorization: "Bearer " + this.token },
        });
        await this.loadQuestions();
      } catch (error) {
        this.errorMessage = "Unable to remove survey question.";
      }
    },
    goBack() {
      this.$router.push(
        "/tinternalcourses/view?id=" + this.$route.query.course_id
      );
    },
  },
};
</script>
